import { initializeFirestore } from 'firebase/firestore';
import app from '.';

const firestore = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
  // Helps Safari/local dev avoid intermittent WebChannel transport issues.
  experimentalAutoDetectLongPolling: true
});

export default firestore;
